var _a;
import { Board, Size, } from "../../core";
export class SoccerBoard extends Board {
    constructor() {
        super(_a.size);
    }
    static reconstruct(tokens, drawings, lines, texts) {
        const board = new _a();
        this.hydrate(board, tokens, drawings, lines, texts);
        return board;
    }
}
_a = SoccerBoard;
SoccerBoard.sizeScale = 20 / 71;
SoccerBoard.size = new Size(71 * _a.sizeScale, 51 * _a.sizeScale);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic29jY2VyLWJvYXJkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3Nwb3J0cy9zb2NjZXIvc29jY2VyLWJvYXJkLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxPQUFPLEVBQ0wsS0FBSyxFQUtMLElBQUksR0FDTCxNQUFNLFlBQVksQ0FBQztBQUVwQixNQUFNLE9BQU8sV0FBWSxTQUFRLEtBQUs7SUFDcEM7UUFDRSxLQUFLLENBQUMsRUFBVyxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQzFCLENBQUM7SUFNRCxNQUFNLENBQUMsV0FBVyxDQUNoQixNQUFnQyxFQUNoQyxRQUE0QixFQUM1QixLQUFzQixFQUN0QixLQUE4QjtRQUU5QixNQUFNLEtBQUssR0FBRyxJQUFJLEVBQVcsRUFBRSxDQUFDO1FBQ2hDLElBQUksQ0FBQyxPQUFPLENBQUMsS0FBSyxFQUFFLE1BQU0sRUFBRSxRQUFRLEVBQUUsS0FBSyxFQUFFLEtBQUssQ0FBQyxDQUFDO1FBQ3BELE9BQU8sS0FBSyxDQUFDO0lBQ2YsQ0FBQzs7O0FBYnVCLHFCQUFTLEdBQUcsRUFBRSxHQUFHLEVBQUUsQUFBVixDQUFXO0FBRTVCLGdCQUFJLEdBQUcsSUFBSSxJQUFJLENBQUMsRUFBRSxHQUFHLEVBQUksQ0FBQyxTQUFTLEVBQUUsRUFBRSxHQUFHLEVBQUksQ0FBQyxTQUFTLENBQUMsQUFBckQsQ0FBc0QifQ==